import ReactOnRails from 'react-on-rails';

import PDP from 'pages/pdp';
import ProductForm from 'components/ProductForm';

ReactOnRails.register({
  PDP,
  ProductForm,
});
